const KNOWN_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'yahoo.com',
  'icloud.com',
  'live.com',
  'protonmail.com',
  'hotmail.com.ar',
  'yahoo.com.ar',
  'fibertel.com.ar',
  'arnet.com.ar',
  'speedy.com.ar',
  'ciudad.com.ar',
  'telecentro.com.ar',
];

const TYPO_BLOCK_THRESHOLD = 3;

function levenshteinDistance(a: string, b: string): number {
  const m = a.length;
  const n = b.length;
  const dp: number[][] = Array.from({ length: m + 1 }, (_, i) =>
    Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0))
  );
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      dp[i][j] =
        a[i - 1] === b[j - 1]
          ? dp[i - 1][j - 1]
          : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
    }
  }
  return dp[m][n];
}

/** Checks email domain for typos against known popular domains.
 *  Returns blocked=true and a suggestion when distance ≤ TYPO_BLOCK_THRESHOLD. */
export function checkEmailDomain(email: string): { blocked: boolean; suggestion: string | null } {
  const atIndex = email.lastIndexOf('@');
  if (atIndex === -1) return { blocked: false, suggestion: null };

  const domain = email.slice(atIndex + 1).toLowerCase();
  if (!domain) return { blocked: false, suggestion: null };

  if (KNOWN_DOMAINS.includes(domain)) return { blocked: false, suggestion: null };

  let minDistance = Infinity;
  let closestDomain = '';

  for (const known of KNOWN_DOMAINS) {
    const dist = levenshteinDistance(domain, known);
    if (dist < minDistance) {
      minDistance = dist;
      closestDomain = known;
    }
  }

  if (minDistance <= TYPO_BLOCK_THRESHOLD) {
    const user = email.slice(0, atIndex);
    return { blocked: true, suggestion: `${user}@${closestDomain}` };
  }

  return { blocked: false, suggestion: null };
}
